export default "__VITE_ASSET__CObc9vGh__"